"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var StudentOnlineDriversEdSuccessController = /** @class */ (function () {
    function StudentOnlineDriversEdSuccessController($rootScope, $state, VueStoreFactory, $sce) {
        this.$rootScope = $rootScope;
        this.$state = $state;
        this.VueStoreFactory = VueStoreFactory;
        this.successMessage = "";
        this.$sce = $sce;
        // Read the onlinedriversed policy synchronously from the Vuex store
        // (populated at student startup by student.module.ts getCurrentUser).
        var storePolicies = VueStoreFactory.state.auth.policies.policies;
        var odePolicy = storePolicies.find(function (p) { return p.name === "onlinedriversed"; });
        if (odePolicy) {
            var meta = odePolicy.policymeta.find(function (m) { return m.meta_key === "success_message"; });
            this.successMessage = this.$sce.trustAsHtml((meta === null || meta === void 0 ? void 0 : meta.meta_value) || "");
        }
    }
    return StudentOnlineDriversEdSuccessController;
}());
StudentOnlineDriversEdSuccessController.$inject = [
    "$rootScope",
    "$state",
    "VueStoreFactory",
    "$sce",
];
exports.default = StudentOnlineDriversEdSuccessController;
